export const spaceBetween = {
    display: 'flex',
    justifyContent: 'space-between'
};
